@if (control) {
  <div
    class="input-counter"
    [ngClass]="{'input-counter--has-error': control.errors?.maxlength}"
    >
    <ng-content select="[slot='start']"></ng-content>
    @if (control.errors?.maxlength?.requiredLength) {
      {{ 'COMPONENT.input_counter.error' | translate:{count: control.value.length, max: maxLength, diff: control.value.length - maxLength} }}
    } @else {
      {{ 'COMPONENT.input_counter.hint' | translate:{count: (control.value || '').length, max: maxLength} }}
    }
  </div>
}
